const elements = {
  menu: document.querySelector('.header .menus_wrapper'),
  menuBurger: document.querySelector('.header .menu_btn_burger'),
  primaryNavigation: document.getElementById('primary_navigation'),
  appOverlay: document.querySelector('.app-overlay'),
  searchWrapper: document.querySelector('.search-wrapper'),
  searchLink: document.querySelector('.search-link'),
  closeForm: document.querySelector('.search-wrapper .close-form'),
  allMenuItemHasChildren: document.querySelectorAll('.menus_wrapper .menu-item-has-children'),
  allWpSubmenu: document.querySelectorAll('.menus_wrapper .sub-menu')
}

const searchBar = {
  init: function () {
    this.el = elements;
    this.handleClick();
  },
  handleClick: function () {
    this.el.searchLink.addEventListener('click', () => {
      this.el.searchWrapper.classList.toggle('active');
    })
    this.el.closeForm.addEventListener('click', () => {
      this.el.searchWrapper.classList.contains('active') && this.el.searchWrapper.classList.remove('active');
    })
  }
}


const openMenu = (el) => {
  el.menuBurger.classList.add('open')
  el.menu.classList.add('open')
  window.document.body.classList.add('responsive_menu_open')
}

const closeMenu = (el) => {
  el.menuBurger.classList.remove('open')
  el.menu.classList.remove('open');
  window.document.body.classList.remove('responsive_menu_open')
}

const toggleMenu = (el) => {
  if (el.menuBurger.classList.contains('open')) {
    closeMenu(el)
  } else {
    openMenu(el)
  }
}


const subMenu = {
  init: function () {
    this.el = elements;
    this.allCustomSubmenu = document.querySelectorAll('.custom-sub-menu');
    this.toggleSubMenu();
  },
  toggleSubMenu: function () {
    this.el.allMenuItemHasChildren.forEach(item => {
      item.onclick = () => {
        if (item.classList.contains('open')) {
          this.closeAll();
        } else {
          this.closeAll();
          item.classList.add('open');
        }
        // this.handleReturnLinkClick(item);
      }
    })
  },
  closeAll: function () {
    this.el.allMenuItemHasChildren.forEach(item => item.classList.contains('open') && item.classList.remove('open'));
  },
  handleReturnLinkClick: function (el) {
    console.log(el.querySelector('.sub-menu .return-link'));
  }
};



const addContentToSubmenu = {
  init: function () {
    this.el = elements;
    this.el.allMenuItemHasChildren.forEach(data => {
      this.addContent(data.querySelector('a').innerText, data);
    })
  },
  addContent: function (title, rootElement) {
    const wpSubmenu = rootElement.querySelector('.sub-menu');

    // create return link
    const goBackLink = document.createElement('li');
    goBackLink.classList.add('return-link');
    goBackLink.appendChild(document.createTextNode('Retour'));

    // create title element 
    const submenuTitle = document.createElement('li');
    submenuTitle.classList.add('sub-menu-title');
    submenuTitle.appendChild(document.createTextNode(title));

    wpSubmenu.insertAdjacentElement('afterbegin', submenuTitle);
    wpSubmenu.insertAdjacentElement('afterbegin', goBackLink);

    //wrap wordpress submenu in new element
    const customSubMenu = document.createElement('div');
    customSubMenu.classList.add('custom-sub-menu');
    customSubMenu.appendChild(wpSubmenu);

    // append .custom-sub-menu to rootElement
    rootElement.insertAdjacentElement('beforeend', customSubMenu);

  }

};

if (elements.searchWrapper) {
  searchBar.init();
}


if (elements.menu && elements.menuBurger) {
  addContentToSubmenu.init();
  subMenu.init();
  elements.menuBurger.onclick = (e) => {
    e.preventDefault()
    toggleMenu(elements)
  }
}




// WEBPACK FOOTER //
// ./scripts/menu.js